export enum RecurringTransactionFrequency {
    Monthly = 'MONTHLY',
    Weekly = 'WEEKLY',
}
